import React, { Component } from "react";
import { Col, Row, FormGroup, Label, Input, CustomInput, Modal } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  createAmenity,
  removeAmenity,
  getAmenityList,
  getAmenityById,
  updateAmenity,
  getAmenityTypeList,
} from "../../Endpoint/Admin/index";
import { toast } from "react-toastify";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Panel, Table, Chip, Btn, IconBtn, SearchPill, ChipTabs, StatRow, StatCard, Thumb, ConfirmDialog,
} from "../../components/Console/ConsoleUI";
import { canWrite } from "../../services/PermissionService";

/**
 * Amenities catalogue — the icons and names attached to a room, restyled onto
 * the console shell.
 *
 * An amenity is a name, an icon and the type it is filed under, and that is
 * the whole record: the list endpoint strips isActive and both timestamps. So
 * the tiles count what is actually there — how many amenities, how many types
 * are in use, how many are still missing an icon — rather than inventing a
 * trend the API cannot support.
 *
 * Re-skin only: createAmenity / updateAmenity still post the same multipart
 * FormData, and the type dropdown is still filled by getAmenityTypeList().
 */

/** The type name on a list row, which arrives populated. */
const typeName = (a) =>
  (a.amenityType && (a.amenityType.type || a.amenityType.name)) || "";

const typeId = (a) => {
  const t = a.amenityType;
  if (!t) return "";
  return String(t._id || t);
};

class Amenities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewImage: undefined,
      items: [],
      roomtypeData: [],
      isLoaded: false,
      modal: false,
      amenityName: "",
      amenityType: "",
      selectedFile: null, // to store selected file
      handleResponse: null, // handle the API response
      invalidImage: null,
      selectedFileName: "",
      amenityId: null,
      // View-only state — never changes what is fetched.
      search: "",
      filter: "",
      showDeleteModal: false,
      pendingDelete: null,
      actionLoading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.editRoomFeature = this.editRoomFeature.bind(this);
    this.removeRoom = this.removeRoom.bind(this);
    this.getALlluser = this.getALlluser.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      amenityName: "",
      amenityType: "",
      selectedFile: "",
      previewImage: "",
      invalidImage: "",
      amenityId: "",
    });
  }

  handleCloseModal() {
    this.setState({
      modal: false,
    });
  }

  onFileChange(event) {
    // Read the file off the event once and keep it: React 16 pools synthetic
    // events, so re-reading event.target below would log a released-event
    // warning. Same behaviour, one fewer console message.
    const imageFile = event.target.files[0];
    if (!imageFile) return false;

    if (!imageFile.name.match(/\.(jpg|jpeg|png)$/)) {
      this.setState({
        invalidImage: "Please select valid image.",
        previewImage: URL.createObjectURL(imageFile),
      });
      return false;
    } else {
      this.setState({
        selectedFile: imageFile,
        previewImage: URL.createObjectURL(imageFile),
        invalidImage: null,
      });
    }
  }

  roomtypes() {
    getAmenityTypeList()
      .then((result) => {
        this.setState({
          roomtypeData: (result && result.data) || [],
        });
      })
      .catch((error) => {});
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit() {
    // AvForm has already blocked the browser's own submit before calling this;
    // by then React 16 has released the pooled event.
    const formData = new FormData();
    formData.append("amenityName", this.state.amenityName);
    formData.append("amenityType", this.state.amenityType);

    formData.append("amenity", this.state.selectedFile);
    formData.append("amenityId", this.state.amenityId);

    if (this.state.amenityId == "" || this.state.amenityId == null) {
      createAmenity(formData)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                featureName: "",
                selectedFile: null, // to store selected file
                handleResponse: null, // handle the API response
                imageUrl: null, // to store uploaded image path
                invalidImage: null,
                selectedFileName: "",
                previewImage: "",
                amenityId: "",
                amenityType: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Amenity added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateAmenity(formData)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",
                amenityId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success(updateResults.message);
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  editRoomFeature(id) {
    getAmenityById(id)
      .then((results) => {
        this.setState({
          amenityName: results.data.amenityName,
          previewImage: results.data.icon,
          selectedFile: results.data.iconFile,
          amenityId: results.data._id,
          amenityType: results.data.amenityType,
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.setState({ modal: true });
  }

  removeRoom(id) {
    this.setState({ actionLoading: true });
    removeAmenity(id)
      .then((results) => {
        this.getALlluser();
        toast.success(results.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        toast.error("error");
      })
      .finally(() => {
        this.setState({
          actionLoading: false,
          showDeleteModal: false,
          pendingDelete: null,
        });
      });
  }

  getALlluser() {
    getAmenityList().then((result) => {
      this.setState({
        isLoaded: true,
        items: (result && result.data) || [],
      });
    });
  }

  componentDidMount() {
    this.roomtypes();
    this.getALlluser();
  }

  // --- presentation ---------------------------------------------------------

  askDelete = (a) => this.setState({ showDeleteModal: true, pendingDelete: a });

  toggleDeleteModal = () =>
    this.setState({
      showDeleteModal: !this.state.showDeleteModal,
      pendingDelete: null,
    });

  /** Client-side filter over the loaded list. No request is made. */
  visibleAmenities() {
    const { items, search, filter } = this.state;
    const q = search.trim().toLowerCase();
    return (items || []).filter((a) => {
      if (filter && typeId(a) !== filter) return false;
      if (!q) return true;
      return [a.amenityName, typeName(a)]
        .some((v) => String(v || "").toLowerCase().includes(q));
    });
  }

  /** Filter pills: the types that actually appear on a row, with real counts. */
  typeTabs() {
    const items = this.state.items || [];
    const counts = {};
    items.forEach((a) => {
      const id = typeId(a);
      if (!id) return;
      if (!counts[id]) counts[id] = { label: typeName(a) || "Untitled type", n: 0 };
      counts[id].n += 1;
    });
    return [
      { value: "", label: "All", count: items.length },
      ...Object.keys(counts).map((id) => ({
        value: id,
        label: counts[id].label,
        count: counts[id].n,
      })),
    ];
  }

  columns() {
    const write = canWrite();
    return [
      {
        key: "amenityName",
        label: "Amenity",
        render: (a) => (
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                overflow: "hidden",
                flex: "0 0 40px",
                border: `1px solid ${C.tint}`,
              }}
            >
              <Thumb src={a.icon} alt={a.amenityName} icon="spa" height={40} width={40} />
            </div>
            <span style={{ fontSize: 15, color: C.ink }}>
              {a.amenityName || "Untitled amenity"}
            </span>
          </div>
        ),
      },
      {
        key: "amenityType",
        label: "Type",
        width: 200,
        render: (a) =>
          typeName(a) ? (
            <Chip tone="neutral">{typeName(a)}</Chip>
          ) : (
            <span style={{ color: C.taupeLight }}>Not filed</span>
          ),
      },
      {
        key: "icon",
        label: "Icon",
        width: 120,
        render: (a) =>
          a.icon ? (
            <span style={{ color: C.taupe }}>Uploaded</span>
          ) : (
            <span style={{ color: C.taupeLight }}>None yet</span>
          ),
      },
      // Write controls stay behind canWrite(): a view-only account still sees
      // the catalogue, just no way to change it.
      ...(write
        ? [
            {
              key: "actions",
              label: "",
              width: 96,
              align: "right",
              render: (a) => (
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                  <IconBtn
                    icon="edit"
                    title={`Edit ${a.amenityName || "amenity"}`}
                    onClick={() => this.editRoomFeature(a._id.toString())}
                  />
                  <IconBtn
                    icon="delete"
                    tone="bad"
                    title={`Remove ${a.amenityName || "amenity"}`}
                    onClick={() => this.askDelete(a)}
                  />
                </div>
              ),
            },
          ]
        : []),
    ];
  }

  renderModal() {
    const { handleResponse, invalidImage, previewImage, amenityId } = this.state;
    const editing = !!amenityId;

    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle} className="con-modal" centered>
        <div style={{ padding: 30 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <span
              className="ms"
              style={{
                fontSize: 26,
                color: C.brown,
                background: C.iconTint,
                padding: 13,
                borderRadius: 16,
              }}
            >
              spa
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 22, fontWeight: 500, color: C.ink }}>
                {editing ? "Edit amenity" : "Add amenity"}
              </div>
              <div style={{ marginTop: 4, fontSize: 14, color: C.taupe }}>
                {editing
                  ? "Rooms already carrying this amenity pick up the change"
                  : "Appears on any room type it is attached to"}
              </div>
            </div>
            <button
              type="button"
              onClick={this.toggle}
              aria-label="Close"
              style={{
                border: 0,
                background: "transparent",
                color: C.taupeLight,
                cursor: "pointer",
                padding: 4,
                lineHeight: 1,
              }}
            >
              <span className="ms" style={{ fontSize: 22 }}>close</span>
            </button>
          </div>

          <AvForm onValidSubmit={this.handleSubmit}>
            <div style={{ marginTop: 24, display: "flex", gap: 18, alignItems: "flex-start" }}>
              {/* The real file input is unchanged — only hidden, and driven by
                  the tile beside it, so the upload handler and the multipart
                  payload stay exactly as they were. */}
              <div style={{ display: "none" }}>
                <AvField
                  tag={CustomInput}
                  name="file"
                  id="file"
                  type="file"
                  accept="image/*"
                  onChange={this.onFileChange}
                />
              </div>
              <label
                htmlFor="file"
                style={{
                  width: 116,
                  height: 116,
                  borderRadius: 16,
                  border: "1.5px dashed #d9c3a5",
                  background: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  color: C.taupeLight,
                  cursor: "pointer",
                  margin: 0,
                  flex: "0 0 116px",
                  overflow: "hidden",
                }}
              >
                {previewImage ? (
                  <Thumb src={previewImage} alt="Selected icon" icon="spa" height={116} width={116} />
                ) : (
                  <React.Fragment>
                    <span className="ms" style={{ fontSize: 26 }}>add_photo_alternate</span>
                    <span style={{ fontSize: 12 }}>Upload icon</span>
                  </React.Fragment>
                )}
              </label>

              <div style={{ flex: 1, minWidth: 0 }}>
                <Row form>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="amenityName">Amenity name</Label>
                      <AvField
                        type="text"
                        value={this.state.amenityName}
                        onChange={this.handleChange}
                        id="amenityName"
                        name="amenityName"
                        placeholder="e.g. Hairdryer"
                        required
                                  errorMessage="Amenity name is required"
                                />
                    </FormGroup>
                  </Col>
                </Row>
                <Row form>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="amenityType">Amenity type</Label>
                      <Input
                        type="select"
                        name="amenityType"
                        id="amenityType"
                        value={this.state.amenityType}
                        onChange={this.handleChange}
                        required
                      >
                        <option value="">Select amenity type</option>
                        {this.state.roomtypeData.map((e, key) => {
                          return (
                            <option key={key} value={e._id}>
                              {e.type}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
                <div style={{ fontSize: 12, color: C.taupeLight }}>
                  JPG or PNG. The icon is what a guest sees beside the name.
                </div>
              </div>
            </div>

            {invalidImage && (
              <p style={{ marginTop: 12, marginBottom: 0, color: C.red, fontSize: 13 }}>
                {invalidImage}
              </p>
            )}
            {this.state.selectedFileName && (
              <p style={{ marginTop: 8, marginBottom: 0, fontSize: 13, color: C.taupe }}>
                {this.state.selectedFileName}
              </p>
            )}
            {handleResponse && (
              <p
                style={{
                  marginTop: 12,
                  marginBottom: 0,
                  fontSize: 13,
                  color: handleResponse.isSuccess ? C.green : C.red,
                }}
              >
                {handleResponse.message}
              </p>
            )}

            <div style={{ marginTop: 24, display: "flex", gap: 12 }}>
              <button
                type="button"
                onClick={this.toggle}
                style={{
                  flex: 1,
                  height: 52,
                  border: "1px solid #e6d8c4",
                  borderRadius: 26,
                  background: "#fff",
                  color: C.slate,
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              {/* Stays a real submit button — AvForm's required-field check
                  only runs on submit. */}
              <button
                type="submit"
                style={{
                  flex: 1,
                  height: 52,
                  border: 0,
                  borderRadius: 26,
                  background: C.brown,
                  color: "#fff",
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                {editing ? "Save changes" : "Add amenity"}
              </button>
            </div>
          </AvForm>
        </div>
      </Modal>
    );
  }

  render() {
    const { items, isLoaded, search, filter, pendingDelete } = this.state;
    const write = canWrite();
    const visible = this.visibleAmenities();
    const withIcon = (items || []).filter((a) => !!a.icon).length;
    const typesInUse = new Set(
      (items || []).map((a) => typeId(a)).filter(Boolean)
    ).size;

    return (
      <ConsolePage
        title="Amenities"
        subtitle={
          isLoaded
            ? `${(items || []).length} amenit${(items || []).length === 1 ? "y" : "ies"}${
                search.trim() ? ` · ${visible.length} matching` : ""
              }`
            : "Loading amenities…"
        }
        actions={
          <React.Fragment>
            <SearchPill
              value={search}
              onChange={(v) => this.setState({ search: v })}
              placeholder="Name or type"
              width={230}
            />
            <Btn
              kind="quiet"
              icon="label"
              onClick={() => this.props.history.push("/AmenityType")}
            >
              Types
            </Btn>
            {write && (
              <Btn icon="add" onClick={this.toggle}>
                Add amenity
              </Btn>
            )}
          </React.Fragment>
        }
      >

        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <StatRow columns={3}>
            <StatCard icon="spa" value={(items || []).length} label="Amenities" />
            <StatCard icon="label" value={typesInUse} label="Types in use" />
            <StatCard
              icon="image_not_supported"
              value={(items || []).length - withIcon}
              label="Missing an icon"
            />
          </StatRow>

          <ChipTabs
            value={filter}
            onChange={(v) => this.setState({ filter: v })}
            options={this.typeTabs()}
          />

          <Panel style={{ padding: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                padding: "16px 22px",
                borderBottom: `1px solid ${C.panel}`,
              }}
            >
              <div>
                <div style={{ fontSize: 17, fontWeight: 500, color: C.ink }}>All amenities</div>
                <div style={{ marginTop: 3, fontSize: 13, color: C.taupeLight }}>
                  Attach these to a room type to show them to guests
                </div>
              </div>
              <div style={{ fontSize: 14, color: C.taupeLight }}>
                {visible.length} of {(items || []).length} shown
              </div>
            </div>

            <div style={{ padding: "6px 8px" }}>
              {!isLoaded ? (
                <div style={{ padding: "48px 0", textAlign: "center", color: C.taupeLight }}>
                  Loading amenities…
                </div>
              ) : (
                <Table
                  columns={this.columns()}
                  rows={visible}
                  empty={
                    (items || []).length === 0
                      ? "No amenities yet — add the first one to describe a room"
                      : "No amenity matches this filter."
                  }
                />
              )}
            </div>
          </Panel>
        </div>

        {this.renderModal()}

        <ConfirmDialog
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
          onConfirm={() =>
            pendingDelete && this.removeRoom(pendingDelete._id.toString())
          }
          icon="delete"
          title={`Remove ${pendingDelete ? pendingDelete.amenityName : "this amenity"}?`}
          body="It stops appearing on any room type that lists it."
          tip="Deleting cannot be undone — you would have to add the amenity and upload its icon again."
          confirmText="Remove"
          loading={this.state.actionLoading}
        />
      </ConsolePage>
    );
  }
}

export default Amenities;
